<template>
  <footer class="footer">
    <div class="row align-items-center justify-content-lg-between container-fluid mx-0">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="javascript:void(0);" class="font-weight-bold ml-1 text-muted">PKBM</a> -
          <a href="javascript:void(0);" class="font-weight-bold ml-1 text-muted">BINA PANDU MANDIRI</a>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item">
            <i style="width:37px" class="icofont-facebook"></i><a target="_blank" class="nav-link" href="https://www.facebook.com/pkbm.binapandumandiri.96" style="display: initial;">PKBM Bina Pandu Mandiri</a>
          </li>
          <li class="nav-item">
            <i style="width:37px" class="icofont-instagram"></i><a target="_blank" class="nav-link" href="https://www.facebook.com/pkbm.binapandumandiri.96" style="display: initial;">PKBM Bina Pandu Mandiri</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
